import React, { useState } from "react"
import { NavLink } from "react-router-dom"
import "./DNavbar.css"
import { HamburgetMenuClose, HamburgetMenuOpen } from "./Icons"

function DNavbar() {

  const [click, setClick] = useState(false)
  const handleClick = () => setClick(!click)

  return (
    <>
      <nav className="gdnavbar">
        <div className="gdnav-container">
          <NavLink exact to="/" className="navbar-logo">
            <img src="./HomePhotos/Footer/avenueonelogo.png" alt="LOGO" />
          </NavLink>
          <ul className={click ? "gdnav-menu active" : "nav-menu"}>
            <li className="nav-item">
              <NavLink
                exact
                to="/"
                activeClassName="active"
                className="nav-links"
                onClick={handleClick}
              >
                HOME
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/square"
                activeClassName="active"
                className="nav-links"
                onClick={handleClick}
              >
                SQUARE
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/park"
                activeClassName="active"
                className="nav-links"
                onClick={handleClick}
              >
                PARK
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/swissresidencies"
                activeClassName="active"
                className="nav-links"
                onClick={handleClick}
              >
                SWISS RESIDENCIES
              </NavLink>
            </li>
            {/* <li className="nav-item">
              <NavLink
                to="/orchird"
                activeClassName="active"
                className="nav-links"
                onClick={handleClick}
              >
                ORCHIRD
              </NavLink>
            </li> */}
            <li className="nav-item">
              <NavLink
                to="/gallery"
                activeClassName="active"
                className="nav-links"
                onClick={handleClick}
              >
                GALLERY
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/about"
                activeClassName="active"
                className="nav-links"
                onClick={handleClick}
              >
                ABOUT
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/contact"
                activeClassName="active"
                className="nav-links"
                onClick={handleClick}
              >
                CONTACT
              </NavLink>
            </li>
            <li className="nav-item ">
              <NavLink to='https://swissinternationalhotels.com/' target="_blank"
                className="nav-swisslogo">
                <img src="./DowntownPhotos/Navbar/swisslogo.png" alt="" className=" w-[195px]" />
              </NavLink>
            </li>
          </ul>
          <div className="nav-icon" onClick={handleClick}>
            {click ? (
              <span className="icon">
                <HamburgetMenuClose />
              </span>
            ) : (
              <span className="icon">
                <HamburgetMenuOpen />
              </span>
            )}
          </div>
        </div>
      </nav>
    </>
  )
}

export default DNavbar
